import { type AddressData, type UnloadingPointData } from "~/feature/cart/checkout/components/Address";
import { type CartEntry, type LineItem } from "../models/CartData";
import { type CreditCardData, type SupportedPaymentsTypesData } from "../transformers/CheckoutViewDataTransformer";

export interface CartState {
  cartEntries: number[];
  cartEntriesById: Dict<CartEntry>;
  packEntriesById: Dict<LineItem>;
  comment: string;
}

export interface CartPageState {
  accountNumber: string;
  loading: boolean;
  error: boolean;

  requestInFlight: boolean;
  requestInFlightMessage: string;

  dstError: boolean;
}

export interface CheckoutPageStore {
  accountNumber: string;
  addresses: AddressData[];
  soldTo: {
    name: string;
    accNo: string;
    addresses: AddressData[];
  };
  selectedAddress?: AddressData;
  sending: boolean;
  loading: boolean;
  countriesList: { isocode: string; name: string }[];
  canAddAddress: boolean;
  unloadingPoints?: Dict<UnloadingPointData[]>;
  unloadingPoint?: UnloadingPointData;
  defaultCreditCard: CreditCardData | undefined;
  supportedPaymentTypes: SupportedPaymentsTypesData[];

  orderablePackageIds: number[];
  quotablePackageIds: number[];
}
export const initialCartPageState: CartPageState = {
  accountNumber: "",
  loading: true,
  error: false,

  requestInFlight: false,
  requestInFlightMessage: "",

  dstError: false,
};

export const initialCheckoutPageState: CheckoutPageStore = {
  accountNumber: "",
  addresses: [],
  loading: true,
  soldTo: {
    name: "",
    accNo: "",
    addresses: [],
  },
  sending: false,
  canAddAddress: false,
  countriesList: [],
  unloadingPoints: {},
  defaultCreditCard: undefined,
  supportedPaymentTypes: [],
  orderablePackageIds: [],
  quotablePackageIds: [],
};

export const initialCartState: CartState = {
  cartEntries: [],
  cartEntriesById: {},
  packEntriesById: {},
  comment: "",
};
